<template>
    <div class="content-full">
        <div class="bg-image" style="background-image: url('assets/media/photos/photo13@2x.jpg');">
            <div class="bg-black-50">
                <div class="content content-full">
                    <div class="d-flex justify-content-between align-items-center">
                        <h1 class="flex-fill font-size-h2 text-white my-2" v-if="app">
                            {{app.name}} <span class="font-size-lg text-white-75"></span>
                        </h1>
                        <a class="btn btn-dark my-2" href="" @click.prevent="editApiApp">
                            <i class="fa fa-fw fa-pencil-alt"></i><span
                                class="d-none d-sm-inline ml-1"> Edit App</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters flex-md-10-auto">
            <div class="col-md-4 col-lg-5 col-xl-3 order-md-1">
                <div class="content">
                    <div class="d-md-none push">
                        <button type="button" class="btn btn-block btn-hero-dark" data-toggle="class-toggle"
                                data-target="#side-content" data-class="d-none">
                            App Details
                        </button>
                    </div>
                    <div id="side-content" class="d-none d-md-block push">
                        <h2 class="h4 font-w400 mb-3">Completion</h2>
                        <div class="progress push">
                            <div class="progress-bar bg-muted" role="progressbar" style="width: 34%;" aria-valuenow="30"
                                 aria-valuemin="0" aria-valuemax="100">
                                <span class="font-size-sm font-w600">34%</span>
                            </div>
                        </div>
                        <h2 class="h4 font-w400 my-3">About</h2>
                        <p class="mb-2" v-if="app">
                            {{app.description ? app.description : 'No description provided for this app'}}
                        </p>
                        <h2 class="h4 font-w400 my-3">Created </h2>
                        <p class="text-muted">
                            {{app.created_at}}
                        </p>
                        <h2 class="h4 font-w400 my-3">People</h2>
                        <p>
                            <a class="img-link m-1" href="javascript:void(0)">
                                <img class="img-avatar img-avatar48" src="assets/media/avatars/avatar2.jpg" alt="">
                            </a>
                            <a class="img-link m-1" href="javascript:void(0)">
                                <img class="img-avatar img-avatar48" src="assets/media/avatars/avatar3.jpg" alt="">
                            </a>
                            <a class="img-link m-1" href="javascript:void(0)">
                                <img class="img-avatar img-avatar48" src="assets/media/avatars/avatar9.jpg" alt="">
                            </a>
                            <a class="img-link m-1" href="javascript:void(0)">
                                <img class="img-avatar img-avatar48" src="assets/media/avatars/avatar10.jpg" alt="">
                            </a>
                            <a class="img-link m-1" href="javascript:void(0)">
                                <img class="img-avatar img-avatar48" src="assets/media/avatars/avatar12.jpg" alt="">
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-8 col-lg-7 col-xl-9 order-md-0 bg-body-dark">
                <div class="content-full">
                    <div class="js-tasks h-100">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as moment from 'moment';

    export default {
        data(){
            return {
                moment: moment
            }
        },
        computed: {
            app(){
                return this.$store.getters.getApp;
            }
        },
        created() {
            let id = this.$route.params.clientId;
            this.$store.dispatch('loadApp', {id: id });
        },
        methods: {
            editApiApp(){

            }
        }
    }
</script>

<style scoped>

</style>